import { createFileRoute, redirect, useRouter } from "@tanstack/react-router";

import { kycTokenOptions } from "@entities/two-fa/hooks/use-kyc-token";
import { KycVerificationPageConnector } from "@pages/kyc-verification/kyc-verification-page-connector";

import { Route as ProfileRoute } from "./profile";

export const Route = createFileRoute("/_private/kyc-verify")({
  component: RouteComponent,
  loader: async ({ context }) => {
    try {
      await context.queryClient.ensureQueryData(kycTokenOptions());
    } catch (error) {
      throw redirect({ to: ProfileRoute.fullPath });
    }
  },
});

function RouteComponent() {
  const router = useRouter();
  return <KycVerificationPageConnector onGoBack={router.history.back} />;
}
